<template>
  <div class="favorite-match-area bg-gondola3 position-relative z-1 bg-50">
    <div class="container mw-1356">
      <div class="row">
        <div v-for="(item, index) in c.items" :key="index" class="col-lg-6 col-md-6">
          <div class="favorite-match-single-item position-relative z-1 overflow-hidden hover-style1"
            :class="{ 'mb-4 mb-md-0': index === 0 }"
            :data-aos-delay="(index + 1) * 100" data-aos="fade-up" data-aos-duration="1000">
            <div class="hover-style2">
              <h2>{{ item.title }}</h2>
              <RouterLink :to="item.link" class="btn">
                <span class="border-style">{{ item.button_text }}</span>
              </RouterLink>
              <div :class="index === 0 ? 'favorite-match-img' : 'favorite-match-img-2'">
                <img :src="item.image_url || (index === 0 ? img1 : img2)" alt="favorite-match" />
              </div>
              <img :src="item.shape_url || (index === 0 ? shape1 : shape2)" class="favorite-shape" alt="favorite-shape" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <img :src="c.bg_shape_url || bgShape" class="shape shape-8" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "FavoriteMatch",
  setup() {
    const { content: c } = useContent("favorite_match", {
      bg_shape_url: "",
      items: [
        { title: "Don't miss your favorite match", button_text: "View All Football Leagues", link: "/#pricing", image_url: "", shape_url: "" },
        { title: "Don't miss any updated news", button_text: "View All News Channel", link: "/#pricing", image_url: "", shape_url: "" },
      ],
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const img1 = require("@/assets/images/favorite-match-1.png");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const img2 = require("@/assets/images/favorite-match-2.png");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const shape1 = require("@/assets/images/favorite-shape.png");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const shape2 = require("@/assets/images/favorite-shape-2.png");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgShape = require("@/assets/images/shape-8.png");
    return { c, img1, img2, shape1, shape2, bgShape };
  },
});
</script>
